export default [{
    text: 'Прямая аренда',
    value: 'direct',
}, {
    text: 'Субаренда',
    value: 'sublease',
}];
